"use client";

import * as React from "react";
import { cn } from "@/utils/utils";
import { styleDrivers } from "@/utils/componentStyle";

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  /** Icon element to display */
  icon?: React.ReactNode;
  /** Heading text */
  heading?: React.ReactNode;
  /** Description text */
  description?: React.ReactNode;
  /** Action buttons or links */
  actions?: React.ReactNode;
}

/**
 * EmptyState displays a centered message when content is not available.
 * Use it for empty lists, search results, or initial states.
 */
export function EmptyState({
  className,
  icon,
  heading,
  description,
  actions,
  children,
  ...props
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(styleDrivers.emptyState.root, className)}
      {...props}
    >
      {icon && (
        <div className={styleDrivers.emptyState.icon}>{icon}</div>
      )}
      {heading && (
        <h3 className={styleDrivers.emptyState.title}>{heading}</h3>
      )}
      {description && (
        <p className={styleDrivers.emptyState.description}>{description}</p>
      )}
      {actions && (
        <div className={styleDrivers.emptyState.actions}>{actions}</div>
      )}
      {children}
    </div>
  );
}

EmptyState.displayName = "EmptyState";

export default EmptyState;
